import { Stack, styled } from "@mui/material";

const StyleStack = styled(Stack)(({ direction, theme }) => ({
  border: `1px solid ${theme.palette.common.border}`,
  background: "#FCFCFC",
  borderRadius: 8,
  alignItems: direction === "row" ? "center" : "flex-start",
}));

export default StyleStack;
